module.exports = __webpack_public_path__ + "img/docutaxbannermobile.47524b8a.jpg";